"use strict";

class CreatePriceScheduleController {

    constructor($scope, $window, Upload, SSHttpService, SSDateService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSAwsService, SSUserService, SSAnalyticsService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSDateService = SSDateService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.Upload = Upload;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService= SSAnalyticsService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.UNIT_CATEGORIES_MAP = {
          0: {code: 'XX', name: 'Other', className: 'empty'},
          1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
          2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
          3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
          4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
          5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
          6: {code: 'PH', name: 'Penthouse', className: 'ph'},
          7: {code: 'COM', name: 'Commercial', className: 'retail'},
          1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
          2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
          3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
          4000: {code: 'DE', name: 'Detached', className: 'detached'},
          4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
          4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };
        self.selectedStackId = null;
        self.assigned_units_count = '--';
        
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        if(self.data.schedule_id){
            self.getUnitSchedule();
        }
        else{
            self.scheduleEditMode = true;
            self.scheduleParams = {};
            self.scheduleDetails = {
                setAsListPrice: 0
            };
        }
    }

    getUnitSchedule(){
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/unit-price-schedules/' + self.data.schedule_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.unit_price_schedules.length > 0){
                let details = response.data.unit_price_schedules[0];

                if (details.valid_from && details.valid_from != null && details.valid_from != "" && details.valid_from != "0000-00-00 00:00:00") {
                    details.setAsListPrice = 1;
                    details.valid_from = self.SSUtilService.formatUtcToLocalDate(details.valid_from, 'YYYY-MM-DD HH:mm:ss');
                } else {
                    details.setAsListPrice = 0;
                    details.valid_from = "";
                }

                self.scheduleDetails = details;
                self.scheduleParams = angular.copy(self.scheduleDetails);

                self.unitDetails = self.scheduleDetails.unit_price_schedule_details;
                if(self.unitDetails && self.unitDetails.length > 0){
                    try{
                        let assigned_units_arr = [];
                        // Get unique values
                        $.each(self.unitDetails, function(index, obj) { 
                            if(jQuery.inArray(obj.unit_id, assigned_units_arr) == -1){
                                assigned_units_arr.push(obj.unit_id);
                            }
                        });
                        self.assigned_units_count = assigned_units_arr.length;
                    }
                    catch(ex){
                        console.log(ex);
                    }
                }
            }
        });

        self.getUnitStacks(self.property.id);
    }

    importPriceSchedule(file){
        const self = this;

        if(!file){
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.property.id + '/import-unit-price-schedules/' + self.data.schedule_id);

        loading(true);
        self.Upload.upload({
            url: url,
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Price schedule imported successfully");
            self.getUnitSchedule();
            
        }, function (response) {
            loading(false);

            self.SSAlertService.parseAndDisplayError(response);
        });
    }

    exportPriceSchedule(scheduleId){
        const self = this;

        if(!scheduleId){
            console.log('Warning: Schedule Id not defined');
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.property.id + '/price-list-export?unit_price_schedule_id=' + scheduleId);

        /** WEB-2898 DMS : Price List and Price Plans UI improvements
         * Need to send param timezone with local timezone offset **/
        let todayDate = new Date();
        let timezoneOffset = todayDate.getTimezoneOffset();
        timezoneOffset *= -1; // Get the offset from Local time
        let timezoneOffsetParam = (timezoneOffset >= 0 ? '+' : '-') + Math.abs(timezoneOffset);
        url+= (url.indexOf("?") > -1)? "&" : "?";
        url+="timezone_offset_minutes=" + timezoneOffsetParam;

        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Price schedule exported successfully");
    }

    //--------  STACK VIEW FUNCTIONS ----------

    getUnitStacks(property_id) {
        const self = this;

        self.units = null;

        let url = 'properties/'+ property_id +'/stacks';
        let params = {

            'return_property' : true,
            'property_columns' : 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack' : true,
            'stack_columns' : 'id,named_id,name',
            'include_units' : true,
            'unit_columns' : 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.property_stacks;
            self.processServerData();
            self.getPropertyUnitTypes();

        });
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
          if(stack.units){
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
          }
          stack.availableUnits = self.filterAvailableUnits(stack.units);
        });

        // Select first stack by default
        self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
    }

    filterViewStack(className) {
        var buttons = $( "div.scroll" ).find( "button" );

        //Make all visible
        var invisible_buttons = $( "div.scroll" ).find( "button.greyout" );
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if(className) {
          jQuery.each(buttons, function (i, button) {
            if(!$(button).hasClass(className)) {
                $(button).addClass("greyout");
            }
          });
        }
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
          jQuery.each(stack.units, function (j, unit) {
            let category = null;
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
              category = self.UNIT_CATEGORIES_MAP[unit.category];
            } else {
              category = self.UNIT_CATEGORIES_MAP[0];
            }

            if (self.propertyUnitCategories.indexOf(category) == -1) {
              self.propertyUnitCategories.push(category);
            }
          });
        });
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = '';

        if (!unit.category) {
            cls = 'empty';
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = 'sold';
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = 'draft';
        } else {
            cls = 'reserved';
        }

        if(self.unitDetails && self.unitDetails.length > 0){
            jQuery.each(self.unitDetails, function(index, obj){
                if(obj.unit_id == unit.id){
                    cls = 'assigned';
                }
            });
        }

        return cls;
    }

    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED,self.UNIT_STATUS_DRAFT];
        let filtered = [];

        _.each(units, function (unit) {
          if (statuses.indexOf(unit.status) !== -1)
            filtered.push(unit);
        });

        if (self.sortBy) {
          filtered = _.sortBy(filtered, function (item) {
              return item[self.sortBy];
          })
        }

        return filtered;
    }

    toggle_Unit_selection(unit) {
        const self = this;
        // NO ACTION REQUIRED IN THIS CASE
        // STACK VIEW ON THIS PAGE IS TO ONLY SHOW ASSIGNED UNITS
    }

    //-------- END: STACK VIEW FUNCTIONS ----------

    createSchedule(){
        const self = this;

        self.scheduleErrors = {};
        // Validate form input
        if(!self.validateForm()){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                
                // Call 'priceScheduleApi' for 'Create/Update' schedule
                loading(true);
                self.priceScheduleApi().then(function (response) {
                  loading(false);
                  if (response instanceof Error) {
                      self.SSAlertService.parseAndDisplayError(response);
                      return;
                    }

                    self.SSAlertService.success('Success!', 'Schedule updated successfully.');

                    let details = response.data.UnitPriceSchedule;

                    if (details.valid_from && details.valid_from != null && details.valid_from != "" && details.valid_from != "0000-00-00 00:00:00") {
                        details.setAsListPrice = 1;
                        details.valid_from = self.getFormattedDate(details.valid_from);
                    } else {
                        details.setAsListPrice = 0;
                        details.valid_from = "";
                    }

                    self.scheduleDetails = details;
                    self.scheduleParams = angular.copy(self.scheduleDetails);

                    if(self.data.schedule_id){
                        self.scheduleEditMode = false;
                    }
                    else{
                        self.data.schedule_id = self.scheduleDetails.id;
                        self.$window.location.href = '/developer/properties/' + self.property.named_id + '/create-schedule/' + self.scheduleDetails.id;
                    }
                });
            }
        );
    }

    priceScheduleApi() {
        const self = this;

        // Schedule Update API url: PUT /sec/developer/properties/{propertyId}/update-unit-price-schedules/{scheduleId} 
        // Schedule Post API url: POST /sec/developer/properties/{propertyId}/add-unit-price-schedules
        
        var params = {
            name: self.scheduleParams.name
        };

        params["enforce_on_reserved_units"] = self.scheduleParams.enforce_on_reserved_units;

        if (self.scheduleDetails.setAsListPrice == 1) {
            params["valid_from"] = self.getParamsDate(self.scheduleParams.valid_from);
        } else {
            self.scheduleParams.valid_from = "";
            self.scheduleDetails.valid_from = "";
            params["valid_from"] = null;
        }

        if(self.data.schedule_id){
            // For PUT API
            var url = 'sec/developer/properties/' + self.property.id + '/update-unit-price-schedules/' + self.data.schedule_id;
        }
        else{
            // For POST API
            var url = 'sec/developer/properties/' + self.property.id + '/add-unit-price-schedules';
        }

        return {
          then: function (callback) {
            if (!self.data.schedule_id) {
              self.SSHttpService.postAPIRequest(url, params).then(function (responseObj) {
                callback(responseObj);
              });
            } else {
              self.SSHttpService.putAPIRequest(url, params).then(function (responseObj) {
                callback(responseObj);
              });
            }
          }
        }
    }

    validateForm(){
        const self = this;

        let isValid = true;

        if(!self.scheduleParams){
            return false;
        }

        if(!self.scheduleParams.name){
            self.scheduleErrors.name = 'The name field is required.';
            isValid = false;
        }

        if (self.scheduleDetails.setAsListPrice == 1) {
            if(!self.scheduleParams.valid_from){
                self.scheduleErrors.valid_from = 'The valid_from field is required.';
                isValid = false;
            }
        }

        return isValid;
    }

    getParamsDate(date){
        const self = this;

        try{
            if(date != '' && date != null) {
                // Split date and time on the basis of white-space
                var date_time = date.split(" ");

                var date = date_time[0];

                if(date_time.length > 1){
                    var time = date_time[1];
                    // Server accepts time as 'hh:mm:ss' but jQuery timepicker is 'hh:mm'
                    if(time.split(':').length == 2){
                        time = time + ':00';
                    }
                }

                if(date.includes("-")){
                    var date_format = date + ' ' + time;
                }
                else{
                    var res = date.split("/", 3);
                    var date_format = res[2] + '-' + res[1] + '-' + res[0] + ' ' + time;
                }

                if(date_format) {
                    var localDate = new Date(self.parseDate(date_format));
                    var utcFormat = moment(localDate).utc().format('YYYY-MM-DD HH:mm:ss');
                }

                return utcFormat;
            }
            else{
                return null;
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    parseDate(date) {
        const self = this;
        
        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                var local = self.UtctoLocal(date);

                return local;
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    UtctoLocal(UTCDateString){
        const self = this;

        var convertdLocalTime = new Date(UTCDateString);

        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;

        convertdLocalTime.setHours(convertdLocalTime.getHours() -  hourOffset);

        var dateObj = new Date(convertdLocalTime);

        var _date = self.dateFormat(dateObj);

        return _date;
    }

    dateFormat(now) {
        const self = this;

        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
        var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
        var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
        var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
        var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }

        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    }

    assignUnits(){
        const self = this;

        if(self.data.schedule_id){
            let url = '/developer/properties/' + self.property.id + '/price-schedules/' + self.data.schedule_id;
            self.$window.location.href = url;
        }
    }

    cancelChanges() {
        const self = this;

        self.scheduleEditMode = false;

        self.scheduleParams = angular.copy(self.temp_schedule_params);
        self.scheduleDetails = angular.copy(self.temp_schedule_details);
    }

    prepareEdit() {
        const self = this;

        self.scheduleEditMode = true;

        self.temp_schedule_params = angular.copy(self.scheduleParams);
        self.temp_schedule_details = angular.copy(self.scheduleDetails);
    }
    // WEB-2841 DMS: Price Plan UI Flow Changes
    checkAnyUnitPriceUpdated() {
        const self = this;
        if(self.scheduleDetails.unit_price_schedule_details.length <= 0){
            self.temp_schedule_details.setAsListPrice = 0;
            self.scheduleDetails = angular.copy(self.temp_schedule_details);
            self.temp_schedule_params.enforce_on_reserved_units = 0;
            self.scheduleParams = angular.copy(self.temp_schedule_params);
            self.SSAlertService.warning('', 'Please first add the new price plan.');
        }
    }
}

CreatePriceScheduleController.$inject = ['$scope', '$window', 'Upload', 'SSHttpService', 'SSDateService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSAwsService', 'SSUserService','SSAnalyticsService','SSConfirmationService'];
app.controller('CreatePriceScheduleController', CreatePriceScheduleController);

app.directive("datepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            showTimePicker: false,
            showSecond:false,
            showMillisec:false,
            showMicrosec:false,
            showTimezone:false
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});



